// @import dependencies
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import React, { CSSProperties, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2'
// @end dependencies

// @import hooks
// @end

// @import components
// @end components

// @import types
// @end types

// @import services
import UserService from 'app_services/user/userService';
// @end services

// @import hooks
import { useSelector, useDispatch } from 'react-redux';
// @end hooks

// @import actions
import { CombinedReducers } from 'app_events/index';
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ProfileInformationInteraction.scss'
import { updateUserDataAction } from 'app_events/auth/actions';
import UserFormModuleLayout from '../campus/user/formUser/formUser';
import UserFormSkeleton from './formUserSkeleton';
import { UserFormGeneralInfoInputs } from 'app_types/userTypes';
// @end styles

interface IProfileInformationInteractionProps {
  className?: string;
  style?: CSSProperties;
  id?: string;
  show: boolean;
  onClose?: (data?: any) => {};
}

const ProfileInformationInteraction: React.FC<IProfileInformationInteractionProps> = (props) => {

  const userService = new UserService();
  const user = useSelector((store: CombinedReducers) => store?.auth?.user?.data);
  const [userData, setUserData] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)

  const dispatch = useDispatch();

  const handleCloseModal = async () => {
    if (props.onClose) {
      const newData = user;
      if (newData) {
        newData.reviewData = {
          status: 'reviewed',
          lastReview: new Date()
        };
        dispatch(updateUserDataAction(newData));
      }
      await Swal.fire(
        `Información guardada`,
        `Recuerda que puedes editar tu perfil cuando lo necesites`,
        'success'
      )
      props.onClose({reload: true});
    }
  }

  useEffect(() => {
    getUser()
  }, [user])

  const getUser = async () => {
    if (user?.id) {
      const userResponse = await userService.getOne(user?.id || '')
      if (userResponse) {
        setUserData(userResponse)
        setLoading(false)
      }
    }
  }

  return(
    <Modal
      show={props.show}
      onHide={handleCloseModal}
      centered
      backdrop="static"
      keyboard={false}
      className='modal-profile-information-interaction'
    >
      <Modal.Body>
          <TextComponent
            type='subtitle'
            className='subtitle-modal-interaction'
          >
            Estimado estudiante
          </TextComponent>
          <TextComponent
            type='text'
            className='text-modal-interaction'
          >
            Por favor revise y actualice (si aplica) sus datos. Esta información es la que se tendrá en cuenta para las notificaciones y la generación de su certificado. 
          </TextComponent>
        {loading ? (
          <UserFormSkeleton />
        ): (
          <>
            <UserFormModuleLayout
              userId={user?.id || ''}
              user={userData}
              handleClose={handleCloseModal}
              reviewUserInformation={true}
              inputs={[
                UserFormGeneralInfoInputs.FIRST_NAME,
                UserFormGeneralInfoInputs.LAST_NAME,
                UserFormGeneralInfoInputs.PHONE_NUMBER,
                UserFormGeneralInfoInputs.EMAIL,
                UserFormGeneralInfoInputs.TIMEZONE,
                UserFormGeneralInfoInputs.CULTURE
              ]}
            />
          </>
        )}

      </Modal.Body>
    </Modal>
  );
}

export default ProfileInformationInteraction;
